import extractInterfaceName from "../extractInterfaceName";
import extractDescription from "../extratcDescptionInterface";
import isTrafficOrPower from "../isTrafficOrPowerItem";
import uniqueItems from "../removeDuplicateItens";

const extractInterfaces = (itens) => {
  const uniqueInterfaces = Array.from(
    new Map(
      uniqueItems(itens)
        .filter(
          (item) => item?.key_?.includes("[") && isTrafficOrPower(item?.key_)
        )
        .map((item) => {
          const interfaceName = extractInterfaceName(item?.key_);
          return {
            interface: interfaceName,
            hostid: item?.hostid,
            description: extractDescription(interfaceName, item?.name),
          };
        })
        .filter(Boolean) // Remove valores undefined
        .map((obj) => [obj?.interface, obj])
    ).values()
  );
  return uniqueInterfaces;
};

export default extractInterfaces;
